import { useContext } from 'react';

import { XYChartCustomTooltipContext } from '../context/XYChartCustomTooltip.context.js';

export const useXYChartCustomTooltip = () =>
  useContext(XYChartCustomTooltipContext);
